import AnimatedLogo from './AnimatedLogo';
export default AnimatedLogo;
